import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let tokenGetter = null;
export const setTokenGetter = (fn) => {
  tokenGetter = fn;
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use(async (config) => {
  if (tokenGetter) {
    const t = await tokenGetter();
    if (t) config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0]}: ${x.msg}`).join(", ");
  return d?.message || e?.message || "Something went wrong";
};

export async function downloadFile(url, fallbackName) {
  const res = await api.get(url, { responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const m = cd.match(/filename="?([^"]+)"?/);
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = m ? m[1] : fallbackName;
  a.click();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}
